import React from 'react'
import calender from "../../assets/images/calender.png";
import InstituteAutocomplete from '../../components/status/ProjectTable/InstituteSearch';
import { useState, useEffect } from 'react';
import moment from 'moment';
import axiosInstance from '../../helpers/axios';
import Datetime from 'react-datetime';
import search from "../../assets/images/search.png";
import { Box,CircularProgress } from "@mui/material";
import { useSelector } from "react-redux";
import { useCurrentUser } from '../../hooks/useCurrentUser';



export default function PercentageReport() {
    const[snapshotDate,setSnapshotDate]=useState('')
    const [id,setId]=useState(null)
    const productTypeSelected = useSelector(
        (state) => state.ProductTypeFilter.selectedProductType
    );
  const decode = useCurrentUser();
  const user = null;
    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState('')
     
      let monthEndDate = null;

    if (snapshotDate) {
            const parsedDate = moment(snapshotDate, ["MMMM YYYY", "YYYY-MM"], true);
            if (parsedDate.isValid()) {
            monthEndDate = parsedDate.endOf("month").format("YYYY-MM-DD");
            }
        }

      useEffect(() => {
       
            const prevMonthEndDate = moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD');
         
             let queryParams = {};
         
         
             if (prevMonthEndDate) {
               queryParams.snapshotMonth = prevMonthEndDate;
               
             }
          if (productTypeSelected && productTypeSelected !== "all") {
              queryParams.loanType = Number(productTypeSelected);
          }
         
             axiosInstance.get('/analytics/get-rollback-percentage', {
               headers: {
               },
               params: queryParams 
             })
             .then((res) => {
               setData(res?.data?.data);
             })
             .catch((error) => {
             });     
           
      }, [productTypeSelected]); 



        const handleInputChange = (id) => {
            setIsLoading(true)
            let queryParams = {}
            const prevMonthEndDate = moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD');    
    
          if (monthEndDate) {
              queryParams.snapshotMonth = monthEndDate;
            } else {
              queryParams.snapshotMonth = prevMonthEndDate;
            }
            if(id){
              queryParams.instituteId = id
            }
    
            if (productTypeSelected && productTypeSelected !== "all") {
                queryParams.loanType = Number(productTypeSelected);
            }
        
            axiosInstance.get('/analytics/get-rollback-percentage',{
              params:queryParams,
              headers: {
              },
            }).then((res) => {
               setData(res?.data?.data);
                setIsLoading(false);
             }).catch((error) => {
              alert(error?.response?.data?.message)
              console.error("Error fetching filtered data:", error);
            });
        
             };

        const handleClearFilter =()=>{
                    window.location.reload()
                    }
    
  return (
     


             <><div
          style={{
              display: 'flex',
              flexWrap: 'wrap',
              alignItems: 'center',
              gap: '16px',
              marginBottom: '20px',
              justifyContent: 'flex-start',
          }}
      >

          <div
              style={{
                  height: '30px',
                  width: '15em',
                  borderRadius: '20px',
                  flexShrink: 0,
              }}
          >
             <Datetime
                closeOnSelect={false}
                dateFormat="YYYY-MM"
                timeFormat={false}
                onChange={(event) => {
                    if (event && event.format) {
                    setSnapshotDate(event.format("MMMM YYYY"));
                    } else {
                    setSnapshotDate("");
                    }
                }}
                locale="en-gb"
                isValidDate={(currentDate) => {
                    // Allow current month and all past months, disable only future months
                    return currentDate.isSameOrBefore(moment(), "month");
                }}
                inputProps={{
                    placeholder: "Select Snapshot Month",
                    style: {
                    height: "36px",
                    fontFamily: "Inter-Medium",
                    backgroundImage: `url(${calender})`,
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "5px center",
                    backgroundSize: "15px 15px",
                    paddingLeft: "30px",
                    fontSize: "14px",
                    color: "#000",
                    border: "1px solid #ccc",
                    borderRadius: "7px",
                    width: "100%",
                    marginTop: "2px",
                    },
                    value: snapshotDate,
                }}
                />
          </div>

          {/* Autocomplete */}
          <div
              style={{
                  height: '36px',
                  fontFamily: 'Inter-Medium',
                  display: 'flex',
                  alignItems: 'center',
                  flexShrink: 0,
              }}
          >
              <InstituteAutocomplete
                  onInstituteSelect={(id) => setId(id)}
                  searchIcon={search}
                  placeholder={decode?.clientId === '98ffb18a-9fee-43a5-91a3-4b2b9d9ae361'
                      ? 'Product Type'
                      : 'Merchant Name'}
                  handleInputChange={handleInputChange}
                  customSx={{ minWidth: 230 }}
                  height={'36px'}
                  borderColor={'#CACCCE'}
                  backgroundColor={'white'} />
          </div>

          {/* Button */}
          <div style={{ flexShrink: 0 }}>
              <button
                  style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: '130px',
                      backgroundColor: '#D22129',
                      height: '34px',
                      borderStyle: 'none',
                      borderRadius: "5px",
                      color: 'white',
                      fontFamily: "Inter-Medium",
                      paddingLeft: '10px',
                      marginTop: '10px',
                      whiteSpace: 'nowrap',
                  }}
                  onClick={() => { handleInputChange(id); } }
              >
                  Search Results
              </button>
          </div>

          <div style={{ flexShrink: 0 }}>
              <button
                  style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: '130px',
                      backgroundColor: '#D22129',
                      height: '34px',
                      borderStyle: 'none',
                      borderRadius: "5px",
                      color: 'white',
                      fontFamily: "Inter-Medium",
                      paddingLeft: '10px',
                      marginTop: '10px',
                      whiteSpace: 'nowrap',
                  }}
                  onClick={() => { handleClearFilter(); } }
              >
                  Clear Filter
              </button>
          </div>
      </div>
      <div>
        

               <div   style={{
                  marginTop: '20px',
                  marginRight: '10px',
                  borderRadius: '12px',
                  borderStyle: 'solid',
                  borderColor: '#ffffffff',
                  boxShadow: '0 4px 16px rgba(0, 0, 0, 0.06)',
                  backgroundColor: '#f9f9f9',
                  padding: '20px',
                }}>

                    {isLoading ? (
                                      <Box style={{ display: 'flex',alignItems:'center',justifyContent:'center',padding:'15%'}}>
                                      <CircularProgress />
                                    </Box>
                                    ):
                  <table
                      className="tables"
                      style={{
                          marginRight: '10px',
                          marginTop: '20px',
                          borderRadius: '5px',
                          boxShadow: '0 4px 10px rgba(0, 0, 0, 0.05)',
                      }}
                  >
                      <thead className="table-heading">
                          <tr>
                              <th style={{ fontSize: '14px', cursor: 'pointer', width: '10%', fontFamily: 'Inter-Medium', paddingLeft: '10px' }}>From Bucket</th>
                              <th style={{ fontSize: '14px', cursor: 'pointer', width: '10%', fontFamily: 'Inter-Medium' }}>CE %</th>
                              <th style={{ fontSize: '14px', cursor: 'pointer', width: '10%', fontFamily: 'Inter-Medium' }}>Curr %</th>
                              <th style={{ fontSize: '14px', cursor: 'pointer', width: '10%', fontFamily: 'Inter-Medium' }}>RollForward %</th>
                              <th style={{ fontSize: '14px', cursor: 'pointer', width: '10%', fontFamily: 'Inter-Medium' }}>Total loans</th>
                          </tr>
                      </thead>
                       <tbody className="table-body">
                        {Array.isArray(data) &&
                            data.map((item, index) => (
                            <tr key={index}>
                                <td className="table-row" style={{ lineHeight: '25px', fontSize: "14px",cursor: "pointer",width: "10em",fontFamily: "Inter-Medium",color: "#667085" }}>{item?.from_bucket}</td>
                                <td className="table-row" style={{ lineHeight: '25px', fontSize: "14px",cursor: "pointer",width: "10em",fontFamily: "Inter-Medium",color: "#667085" }}>{item?.CE_percent}%</td>
                                <td className="table-row" style={{ lineHeight: '25px', fontSize: "14px",cursor: "pointer",width: "10em",fontFamily: "Inter-Medium",color: "#667085"  }}>{item?.Cure_percent}%</td>
                                <td className="table-row" style={{ lineHeight: '25px', fontSize: "14px",cursor: "pointer",width: "10em",fontFamily: "Inter-Medium",color: "#667085" }}>{item?.RollForward_percent}%</td>
                                <td className="table-row" style={{ lineHeight: '25px', fontSize: "14px",cursor: "pointer",width: "10em",fontFamily: "Inter-Medium",color: "#667085"  }}>{item?.total_loans}</td>
                            </tr>
                            ))}
                        </tbody>
                  </table>}
               </div>   
         
          </div></>


              
                     
  )
}
 